'use strict'

var scoped = /:scope/

/* Go one step back in window history */
export function goBack() {
  window.history.back();
}

/* Check if DOM element elem contains a class named className 
export function hasClass(elem, className) {
  if (elem.classList)
    return elem.classList.contains(className)
  else
    return !!elem.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
    }*/

/* Add a class named className to DOM element elem 
export function addClass(elem, className) {
  if (elem.classList)
    elem.classList.add(className)
  else if (!hasClass(elem, className)) elem.className += " " + className
}*/

/* Remove a class named className to DOM element elem 
export function removeClass(elem, className) {
  if (elem.classList)
    elem.classList.remove(className)
  else if (hasClass(elem, className)) {
    var reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
    elem.className=elem.className.replace(reg, ' ')
  }
  }*/

/* Toggle class named className in DOM element elem */
export function toggleClass(elem, className){
  if (!elem || !className){
    return;
  }

  var classString = elem.className;
  var nameIndex = classString.indexOf(className);
  
  if (nameIndex == -1) {
    classString += ' ' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex+className.length);
  }
  elem.className = classString;
}

/* Encode key and value of sorted by key array data by replacing each instance of certain characters by one, two, three, or four
    escape sequences representing the UTF-8 encoding of the character and concatenate them in URL query format
*/
export function encodeUri(data){
  var keys = Object.keys(data);
  var i, len = keys.length;
  var encodedString = '';

  keys.sort();
  for (i = 0; i < len; i++) {
    var prop = keys[i];
    if (data.hasOwnProperty(prop)) {
      if (encodedString.length > 0) {
          encodedString += '&';
      }
      encodedString += encodeURIComponent(prop) + '=' + encodeURIComponent(data[prop]);
    }
  }
  return encodedString;
}

/* Parses a query string and returns a map of name:value pairs */
export function parseQuery(qstr) {
  var query = {};
  var a = qstr.substr(1).split('&');
  for (var i = 0; i < a.length; i++) {
    var b = a[i].split('=');
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
  }
  return query;
}


/* Send an ajax POST request with uri encoded data array as query string in the body. Function func is the callback */
export function ajaxPost(url, data, func){
  var request = new XMLHttpRequest();
  request.open("POST", url, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  request.onreadystatechange = function(){
    if(func && request.readyState == 4 && request.status == 200){
      func(request);
    }
  };
  request.send(encodeUri(data));
}

/* Create a hidden form with fields created from key value pairs of array parameters und submit the POST request */
export function postToUrl(url, parameters) {
  var form = document.createElement("FORM");
  form.setAttribute('method', 'post');
  form.setAttribute('display', 'none');
  form.setAttribute('action', url);

  for(var key in parameters) {
    var value = parameters[key];
    var field = document.createElement("INPUT");
    field.setAttribute('type', 'hidden');
    field.setAttribute('name', key);
    field.setAttribute('value', value);
    form.appendChild(field);
  }
  document.body.appendChild(form);
  form.submit();
}

export function show(object){
  if(typeof object == 'string'){
    object = document.querySelectorAll(object);
    if(!object.length){
      return false;
    }
  }
  if(!object.length){
    object.classList.remove('hidden');
  }else{
    for(var i=0;i<object.length;++i){
      var elem = object.item(i);
      if(elem){
        elem.classList.remove('hidden');
      }
    }
  }
}

/* Remove child object or childs matching CSS Selector object (if typeof object == string) or DOM element(s) object */
export function remove(object){
  var obj;

  if(typeof object == 'object'){
    obj = object;
  }else if(typeof object == 'string'){
    obj = document.querySelectorAll(object);
    if(!obj.length){
      return false;
    }
  }
  if(obj && !obj.length){
    obj.parentNode.removeChild(obj);
  }else{
    for(var i=0;i<obj.length;++i){
      var elem = elements.item(i);
      elem.parentNode.removeChild(elem);
    }
  }
}

export function hide(object){
  if(typeof object == 'string'){
    object = document.querySelectorAll(object);
    if(!object.length){
      return false;
    }
  }
  if(!object.length){
    object.classList.add('hidden');
  }else{
    for(var i=0;i<object.length;++i){
      var elem = object.item(i);
      if(elem){
        elem.classList.add('hidden');
      }
    }
  }
}

/* Append string content to inner Html of DOM element elem */
export function append(elem, content){
  elem.innerHTML += content;
}


/* Fire event evt on DOM Element obj */
export function fireEvent(obj, evt){
  var fireOnThis = obj;
  if( document.createEvent ) {
    var evObj = document.createEvent('MouseEvents');
    evObj.initEvent( evt, true, true );
    evObj.synthetic = true;
    fireOnThis.dispatchEvent( evObj );
  } else if( document.createEventObject ) { //IE
    var evObj = document.createEventObject();
    envObj.synthetic = true;
    fireOnThis.fireEvent( 'on' + evt, evObj );
  }
}

/* For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
 
export function closest(startElement, selector) {
  var parent = startElement.parentElement;
  if (!parent) return undefined;
  return ((parent.matches(selector)) ? parent : closest(parent, selector));
}
*/

// Set the Focus to the first input Element that matches the selector
/*export function setFocus(selector){
  var inpts = document.querySelectorAll(selector);
  if (inpts.length > 0) {
    inpts.item(0).focus();
  }
}
*/
// jsFadeOut
export function jsFadeOut(element, display){
  element.style.opacity = getComputedStyle(element).opacity;

  function fade() {
    if ((element.style.opacity -= .1) < 0) {
      element.style.display = display || "none";
      element.style.opacity = null;
    } else {
      element.style.opacity-= .1;
      setTimeout(function() {
        requestAnimationFrame(fade);
      }, 100);
    }
  };
  requestAnimationFrame(fade);
}

// jsFadeIn
export function jsFadeIn(element, maxOpacity, display){
  element.style.opacity = 0;
  element.style.display = null;
  var maxOpacity = maxOpacity || 1;
  function fade() {
    var val = parseFloat(element.style.opacity);
    if (!((val += .1) > maxOpacity)) {
      element.style.opacity = val;
      setTimeout(function() {
        requestAnimationFrame(fade);
      }, 30);
    }
  };
  requestAnimationFrame(fade);
}

// get JSON from an URL
export function getJSON(url, data) {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    var query = encodeUri(data);
    xhr.open('get', url+'?'+query, true);
    //xhr.responseType = 'json';
    xhr.onload = function() {
      var status = xhr.status;
      if (status == 200) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject(status);
      }
    };
    xhr.send();
  });
}
export function stopRKey(evt) {
  var evt = (evt) ? evt : ((event) ? event : null);
  var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
  if ((evt.keyCode == 13) && (node.type=="text"))  {return false;}
}

export function resetUrlQuery(){
  // Query löschen
  var href = window.location.href.split(/[?#]/)[0];
  window.history.replaceState({}, '', href);
}
export function addQueryParamUrl(param, value){
  // URL austauschen
  var query = {};
  var query_str = window.location.search;
  
  query = parseQuery(query_str);
  if(query.hasOwnProperty('')){
    delete query[''];
  }
  
  if(query.hasOwnProperty('limit_offset') && param.substr(0,5) != 'order' && param.substr(0,5) != 'limit'){
    delete query['limit_offset'];
    document.querySelector('.GridTable input[name="limit_offset"]').value = 0;
  }
  
  if(value){
    query[param] = value;
  }else{
    delete query[param];
  }
  
  var nquery_str = '?'+ encodeUri(query);
  var href = window.location.href.split(/[?#]/)[0];
  if(nquery_str.length>1){
    href = href + nquery_str;
  }
  window.history.replaceState({}, '', href);
}
